import { SafeAreaView } from "@hg/layouts"
import { useCallback } from "react"

import { i18n } from "@/i18n"
import { GlobalView, useSetGlobalView, useTransitionStore } from "@/store"
import StrokeText from "../StrokeText"

import styles from "./index.module.scss"

const RecallEntry = () => {
    const setGlobalView = useSetGlobalView()
    const fadeTransition = useTransitionStore((s) => s.fadeTransition)

    const onClick = useCallback(() => {
        fadeTransition(() => {
            const url = new URL(window.location.href)
            url.searchParams.append("page", "recall")
            window.history.replaceState({}, document.title, url.toString())
            setGlobalView(GlobalView.RECALL)
        })
    }, [fadeTransition, setGlobalView])

    return (
        <SafeAreaView
            mode="margin"
            edges={["left"]}
            className={styles.recallEntry}
            onClick={onClick}
        >
            <button type="button">
                <StrokeText
                    className={styles.btnText}
                    text={i18n.get("loading.recall_entry")}
                    fontFamily="a한글세상B"
                    fontSize={31}
                    fillColor="#fff"
                    borderWidth={4}
                    borderColor="#564426"
                    offsetY={0}
                    padding={4}
                    baselineAligned
                />
            </button>
        </SafeAreaView>
    )
}

export default RecallEntry
